import React from 'react';
import PropTypes from 'prop-types';
import DownloadForm from './ui/UploadForm/DownloadForm';

const DataDownloadForm = ({
  onClose,
  modalService,
  uiNotificationService,
}) => {

  return (
    <DownloadForm
      onClose={onClose}
      modalService={modalService}
      uiNotificationService={uiNotificationService}
      //uploadStudy={uploadStudy}
    />
  );
};

DataDownloadForm.propTypes = {
  onClose: PropTypes.func
};

export default DataDownloadForm;
